module.exports = __webpack_public_path__ + "img/linkedin.898c0407.png";